import useScreenSize from "../../../hooks/useScreenSize";
import { Container } from "../../common/Container/Container";
import { Header } from "./components/Header";
import { LessonInfo } from "./components/LessonInfo";
import { LessonNavigation } from "./components/LessonNavigation";
import { SyllabusRightColumn } from "./components/SyllabusRightColumn";
import { TabContainer } from "./components/TabContainer";
import { TabContent } from "./components/TabContent";
import { useTeaching, useTeachingInit } from "./hooks/useTeaching";
import { useTeachingMessageInit } from "./hooks/useTeachingMessage";

import "./teaching.scss";

export function Teaching() {
	const { width } = useScreenSize();
	const isDesktop = width > 992;
	const { loading } = useTeaching();
	useTeachingInit();
	useTeachingMessageInit();

	return (
		<Container className="teaching-container" loading={loading} noFooter>
			<div className="main-column">
				<Header />
				<LessonInfo />
				<LessonNavigation />
				<TabContainer />
				<TabContent />
			</div>
			{isDesktop && (
				<div className="right-column">
					<SyllabusRightColumn />
				</div>
			)}
		</Container>
	);
}
